import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "mt-4 text-14px" };
var _hoisted_2 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
var _hoisted_3 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
var _hoisted_4 = ["onClick"];
import { ref, onMounted } from 'vue';
import { backToAfterSignin } from '../../utils';
import { getCookie } from "../../utils/cookies";
import * as $gtag from "vue-gtag";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UserConfirmation',
    setup: function (__props) {
        var timer = ref(30);
        onMounted(function () {
            var interval = setInterval(function () {
                timer.value -= 1; // 1秒ごとにカウントダウンを減少させる
                if (timer.value === 0) {
                    clearInterval(interval); // カウントダウンが0になったらインターバルをクリア
                    goBack(); // 自動的に戻る
                }
            }, 1000);
        });
        var goBack = function () {
            var afterSignin = getCookie('afterSignin');
            if (afterSignin) {
                $gtag.event('registration', { registration_page: afterSignin });
            }
            backToAfterSignin();
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("p", _hoisted_1, [
                    _createTextVNode("登録が完了しました。"),
                    _hoisted_2,
                    _createTextVNode(" " + _toDisplayString(timer.value) + "秒後に元のページへ戻ります。", 1),
                    _hoisted_3,
                    _createTextVNode(" 自動的に戻らない場合は下の「戻る」を押してください。")
                ]),
                _createElementVNode("a", {
                    href: "/",
                    class: "btn-default block mt-16 text-12px",
                    onClick: _withModifiers(goBack, ["prevent"])
                }, "戻る", 8, _hoisted_4)
            ], 64));
        };
    }
});
